angular.module('IndicatorType').controller('IndicatorTypeController', [
  '$scope',
  '$filter',
  '$sce',
  '$timeout',
  '$uibModal',
  '$q',
  'IndicatorTypeService',
  'IndicatorTreeService',
  function ($scope, $filter, $sce, $timeout, $uibModal, $q, IndicatorTypeService, IndicatorTreeService) {
    var categoryPromise = IndicatorTypeService.getIndicatorCategories()
      .then(function (categories) {
        $scope.categories = categories;
        $scope.categoryTree = IndicatorTreeService.buildCategoryTree(categories);
      });
    var indicatorKeysPromise = IndicatorTypeService.getIndicatorKeys()
      .then(function (keys) {
        $scope.indicatorKeys = keys;
      });

    var indicatorType = jQuery('#indicator-type-data'),
        deletedIndicators = [],
        deletedLists = [];
    if(indicatorType.length) {
      $scope.indicatorType = indicatorType.data('indicator-type');
    } else {
      $scope.indicatorType = {
        title: '',
        indicatorTypeKey: '',
        category: {},
        list: []
      };
    }

    $scope.templates = [
      {
        type: "indicator",
        typeLabel: "Indikator",
        id: 2,
        title: '',
        key: '',
        unit: 0,
        defaultValue: 0
      },
      {
        type: "set",
        typeLabel: "Indikator Set",
        id: 1,
        indicators: []
      }
    ];

    $scope.addItem = function (index, item) {
      if (!item.added && !item.uid) {
        if (item.type === 'set') {
          $scope.openIndicatorSet(item);
        } else {
          $scope.openIndicator(item);
        }
      }
    };

    $scope.openIndicatorSet = function (indicatorSet) {
      return $uibModal.open({
        templateUrl: '/_assets/19afb7c62e901835de82505ec5bff8a5/JavaScript/Hyperion/IndicatorType/IndicatorSetModal.html',
        size: 'lg',
        controller: 'IndicatorSetModalController',
        resolve: {
          data: function () {
            return {
              indicatorSet: indicatorSet
            }
          }
        }
      })
        .result
        .then(function (indicatorSet) {})
        .catch(function(indicatorSet){
          $scope.indicatorType.list.splice($scope.indicatorType.list.indexOf(indicatorSet), 1);
        });
    };

    $scope.editIndicator = function(indicator){
      indicator.edit = true;
      $scope.openIndicator(indicator);
    };

    $scope.openIndicator = function (indicator) {
      return $uibModal.open({
        templateUrl: '/_assets/19afb7c62e901835de82505ec5bff8a5/JavaScript/Hyperion/IndicatorType/IndicatorModal.html',
        size: 'lg',
        controller: 'IndicatorModalController',
        backdrop  : 'static',
        resolve: {
          data: function () {
            return {
              indicator: indicator,
              keys: $scope.indicatorKeys
            }
          }
        }
      })
        .result
        .then(function (indicator) {
          if(indicator.edit) $scope.indicatorKeys.splice($scope.indicatorKeys.indexOf(indicator.key), 1);
          $scope.indicatorKeys.push(indicator.key);
          if(indicator.default) {
            // set every default-indicator to zero expect of this one
            $scope.indicatorType.list.map(function(item){
              if(item.indicators) {
                item.indicators.map(function(setIndicator){
                  setIndicator.default = false;
                })
              } else {
                item.default = false;
              }
            });
            indicator.default = true;
          }
        })
        .catch(function(indicator){
          if(!indicator.edit) deleteIndicatorFromAnyList(indicator);
          indicator.edit = false;
        });
    };

    function deleteIndicatorFromAnyList(indicator) {
      $scope.indicatorType.list.map(function(item){
        if(item.indicators) {
            item.indicators.splice(item.indicators.indexOf(indicator), 1);
        } else {
            $scope.indicatorType.list.splice($scope.indicatorType.list.indexOf(indicator), 1);
        }
      });
    }

    $scope.writeIndicatorType = function () {
      IndicatorTypeService.writeIndicatorType($scope.indicatorType, deletedLists, deletedIndicators)
        .then(function(){
          $scope.backToList();
        });
    };

    $scope.backToList = function() {
      window.location.replace(window.location.pathname);
    };

    $scope.deleteListItem = function (item, $index) {
      $scope.indicatorType.list.splice($index, 1);
      if(item.key) $scope.existingKeys.splice(item.key,1);
      if(item.uid) {
        deletedLists.push(item.uid);
        for(var i = 0; item.indicators.length > i; i++) {
          var indicator = item.indicators[i];
          if(indicator.uid && deletedIndicators.indexOf(indicator.uid) === -1) {
            deletedIndicators.push(indicator.uid);
          }
        }
      }
    };

    $scope.deleteIndicator = function (item, indicator, $index) {
      if(item.indicators) {
        item.indicators.splice($index, 1);
      } else {
        $scope.indicatorType.list.splice($index, 1);
      }

      if(indicator.uid) {
        deletedIndicators.push(indicator.uid);
      }
    };

    $scope.deleteIndicatorType = function () {
      IndicatorTypeService.deleteIndicatorType($scope.indicatorType)
        .then(function () {
          $scope.backToList();
        });
    };

    $scope.$watch('indicatorType', function (model) {
      $scope.modelAsJson = angular.toJson(model, true);
    }, true);
  }
]);
